export interface RiskTask {
	id: string;
	name: string;
	sequence: number;
	score: number;
}

export interface Percentage {
	score: string;
	percentage: number;
}

export class ActivityRiskResult {
	public readonly most_serious_risk_tasks: RiskTask[];
	public readonly percentage: Percentage[];

	constructor({ most_serious_risk_tasks = [], percentage = [] }: any) {
		this.most_serious_risk_tasks = most_serious_risk_tasks;
		this.percentage = percentage;
	}
}
